<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div>
      <label class="required">{{ $t('quotation.date') }}</label>
      <a-date-picker
        v-model="model.contract_date"
        format="DD-MM-YYYY"
        valueFormat="DD-MM-YYYY"
        class="ts-w-full"
      ></a-date-picker>
      <div class="validate" v-if="errors.has('contract_date')">
        {{ errors.first('contract_date') }}
      </div>
    </div>
    <div>
      <label>{{ $t('saleContract.referenceNo') }}</label>
      <ReferenceNumber v-model="model" />
      <div class="validate" v-if="errors.has('reference_no')">
        {{ errors.first('reference_no') }}
      </div>
    </div>
    <div>
      <label>{{ $t('saleContract.projectName') }}</label>
      <input
        v-model.trim="model.project_name"
        type="text"
        class="form-control"
      />
      <div class="validate" v-if="errors.has('project_name')">
        {{ errors.first('project_name') }}
      </div>
    </div>
  </div>
</template>

<script>
import ReferenceNumber from './reference-number.vue'
import { Errors } from 'form-backend-validation'
export default {
	name: 'refDate',
	props: ['value', 'validate'],
	components: {
		ReferenceNumber,
	},
	data() {
		return {
			errors: new Errors(),
			model: {}
		}
	},
  created() {
    this.model = this.value
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  }
}
</script>